import {
	AccessibilityType,
	Destination,
	Experience,
	Facility,
	MealOption,
	OffersType,
	PaymentOption,
	Period,
	ProductType,
	Province,
	Region,
	RentalUnit,
	RoomType,
	TargetAudience,
	Transportation,
} from '@toevla-webapplications/core';
import { Activity } from './activity.model';
import { OfferImage } from './offer-image.model';
import { Condition } from './condition.model';
import { Theme } from './theme.model';
import { PaymentMethod } from './payment-method.enum';

export class Offer {
	id: string;
	accessibilityDescription: string;
	accessibilityGroups: boolean;
	accessibilityLabel?: string;
	accommodationPriceType?: string;
	activities?: Activity[];
	additionalPayingActivities: boolean;
	bookingEmail: string;
	bookingUrl: string;
	box: string;
	checkOfferUrl: string;
	city: string;
	destinations?: Destination[];
	email: string;
	entranceFee: boolean;
	exclusiveConditions?: Condition[];
	experiences?: Experience[];
	extraPaymentInformation?: string;
	facebook: string;
	facilities?: Facility[];
	fullyBooked: boolean;
	hasOwnGroupPage: boolean;
	hasOwnPage: boolean;
	images: OfferImage[];
	impairments: AccessibilityType[];
	inclusiveConditions?: Condition[];
	indoor: boolean;
	infoPriceDescription: string;
	instagram: string;
	location: LatLng;
	mealOffseason: MealOption;
	mealPeakseason: MealOption;
	meals?: { name: string }[];
	mealsDescription: string;
	minimumNumberOfNights: number;
	name: string;
	newOffer: boolean;
	niceToKnowDescription: string;
	number: string;
	outdoor: boolean;
	overnightNotPossible: boolean;
	overnightPossible: boolean;
	paymentMethod?: PaymentMethod;
	paymentOption?: PaymentOption;
	periods?: Period[];
	phone: string;
	postalcode: string;
	poster?: OfferImage;
	price?: number;
	priceBasedRentalUnitId: string;
	priceOffseason?: number;
	pricePeakseason?: number;
	pricePublished: boolean;
	promotitle: string;
	promodescription: string;
	province: Province;
	region: Region;
	rentalunits?: RentalUnit[];
	reservationEmail?: string;
	reservationIndividualBookingEmail?: string;
	reservationGroupBookingEmail?: string;
	reservationTelephone?: string;
	roomtypes?: RoomType[];
	street: string;
	subtype: ProductType;
	targetAudiences?: TargetAudience[];
	themes?: Theme[];
	transportations?: Transportation[];
	type: OffersType;
	website: string;
}

class LatLng {
	lat: number;
	lon: number;
}
